import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const ProductoSchema = yup.object().shape({
  orden: yup.number().optional().nullable(),
  nombre: yup.string().required("errors.producto.nombre.required").default(""),
  cantidad: CantidadSchema.typeError("errors.producto.cantidad.type")
    .required("errors.producto.cantidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ unidad: { codigo: "" } }),
  operacionesUnitarias: yup
    .array()
    .min(1, "errors.producto.operacionesUnitarias.min")
    .required("errors.producto.operacionesUnitarias.requireds")
    .default([]),
});
